import type {
  FormCategoryRequest,
  FormCategorySimpleResponse,
  GetListRequestV2,
  GetListResponseOfFormCategorySimpleResponse,
  SelectOption,
} from 'src/api/ProactApiClient';
import {formCategoryApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

// Form definition responses embed the category name, so both tags invalidate together.
const FORM_CATEGORY_TAGS = ['FormCategories', 'FormDefinitions'] as const;

export const formCategoryApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getFormCategoryListV2: builder.query<
      GetListResponseOfFormCategorySimpleResponse,
      GetListRequestV2
    >({
      queryFn: clientQuery(params => formCategoryApiClient.listV2(params)),
      providesTags: ['FormCategories'],
    }),
    getFormCategorySelectOptions: builder.query<SelectOption[], void>({
      queryFn: clientQuery(() => formCategoryApiClient.listSelectOptions()),
      providesTags: ['FormCategories'],
    }),
    createFormCategory: builder.mutation<
      FormCategorySimpleResponse,
      FormCategoryRequest
    >({
      queryFn: clientQuery(request => formCategoryApiClient.create(request)),
      invalidatesTags: [...FORM_CATEGORY_TAGS],
    }),
    updateFormCategory: builder.mutation<
      FormCategorySimpleResponse,
      FormCategoryRequest
    >({
      queryFn: clientQuery(request => formCategoryApiClient.update(request)),
      invalidatesTags: [...FORM_CATEGORY_TAGS],
    }),
    deleteFormCategory: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => formCategoryApiClient.delete(id)),
      invalidatesTags: [...FORM_CATEGORY_TAGS],
    }),
  }),
});

export const {
  useGetFormCategoryListV2Query,
  useGetFormCategorySelectOptionsQuery,
  useCreateFormCategoryMutation,
  useUpdateFormCategoryMutation,
  useDeleteFormCategoryMutation,
} = formCategoryApi;
